import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Icon, { IconProps } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, SPACING } from "@store/theme/design";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface OutOfMarketNoticeStyles {
    warningIcon?: IconProps;
    wrapper?: InjectableCss;
    warningText?: TypographyProps;
    submitButton?: ButtonPresentationProps;
}

export const outOfMarketNoticeStyles: OutOfMarketNoticeStyles = {
    warningIcon: {
        src: AlertTriangle,
        color: COLORS.primary.base,
        size: 22,
        css: css`
            float: left;
            margin-right: ${SPACING.xxsmall};
        `,
    },
    wrapper: {
        css: css`
            display: inline-block;
            overflow: auto;
            border: 2px solid ${COLORS.success};
            background: ${COLORS.successBg};
            padding: ${SPACING.xsmall};
            border-radius: 4px;
        `,
    },
    warningText: {
        size: 16,
        css: css`
            color: ${COLORS.text.light};
            margin-bottom: ${SPACING.xsmall};
        `,
    },
    submitButton: {
        css: css``,
    },
};

const styles = outOfMarketNoticeStyles;

const OutOfMarketNotice = ({ product }: Props) => {
    if (!product.properties.isOutOfMarketMessage) {
        return null;
    }

    return (
        <StyledWrapper>
            <Typography {...styles.warningText} as="p">
                <Icon {...styles.warningIcon} />
                {product.properties.isOutOfMarketMessage}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(OutOfMarketNotice),
    definition: {
        displayName: "Out of market notice",
        group: "Catalog",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
